var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.error,"variant":"danger"}},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.errors)?_c('ul',_vm._l((Object.values(_vm.errors)),function(error){return _c('li',{key:error.id},[_vm._v(" "+_vm._s(error[0])+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }